import React from "react";
import { FiShoppingCart, FiHeart, FiSearch } from "react-icons/fi";

export default function Urunlerimiz() {
  const products = [
    {
      id: 1,
      name: "Zarif Gümüş Kolye",
      price: 249,
      category: "Kolyeler",
      image: "/kolye1.jpg"
    },
    {
      id: 2,
      name: "Minimalist Gümüş Küpe",
      price: 179,
      category: "Küpeler",
      image: "/kupe1.jpg"
    },
    {
      id: 3,
      name: "Şık Gümüş Bileklik",
      price: 219,
      category: "Bileklikler",
      image: "/bileklik1.jpg"
    },
    {
      id: 4,
      name: "Özel Tasarım Yüzük",
      price: 199,
      category: "Yüzükler",
      image: "/yuzuk1.jpg"
    },
    {
      id: 5,
      name: "Doğal Taşlı Kolye",
      price: 279,
      category: "Kolyeler",
      image: "/kolye2.jpg"
    },
    {
      id: 6,
      name: "İnce Gümüş Halka Küpe",
      price: 159,
      category: "Küpeler",
      image: "/kupe2.jpg"
    },
    {
      id: 7,
      name: "Hasır Örgü Bileklik",
      price: 239,
      category: "Bileklikler",
      image: "/bileklik2.jpg"
    },
    {
      id: 8,
      name: "Taşlı Gümüş Yüzük",
      price: 229,
      category: "Yüzükler",
      image: "/yuzuk2.jpg"
    }
  ];

  const categories = ["Tümü", "Kolyeler", "Küpeler", "Bileklikler", "Yüzükler"];

  return (
    <div className="min-h-screen bg-[#fefae0]">
      {/* Üst Navigasyon (Ana sayfayla aynı) */}
      

      {/* Ürünler Hero Bölümü */}
      <div className="bg-[#2f2f2f] text-[#fefae0] py-16 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-serif mb-4">Gümüş Takı Koleksiyonumuz</h1>
          <p className="text-lg md:text-xl max-w-2xl mx-auto">El yapımı özel tasarımlarımızla hazırlanmış birbirinden şık gümüş takılar</p>
        </div>
      </div>

      {/* Filtreleme ve Arama */}
      <div className="max-w-6xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-8">
          <div className="flex space-x-2 overflow-x-auto pb-2 w-full md:w-auto">
            {categories.map((category) => (
              <button
                key={category}
                className={`px-4 py-2 rounded-full whitespace-nowrap ${category === "Tümü" ? "bg-[#2f2f2f] text-[#fefae0]" : "bg-white text-[#2f2f2f]"} hover:bg-[#2f2f2f] hover:text-[#fefae0] transition`}
              >
                {category}
              </button>
            ))}
          </div>
          <div className="relative w-full md:w-64">
            <input
              type="text"
              placeholder="Ürün ara..."
              className="w-full pl-10 pr-4 py-2 rounded-full border border-[#2f2f2f] focus:outline-none focus:ring-2 focus:ring-[#2f2f2f]"
            />
            <FiSearch className="absolute left-3 top-3 text-[#2f2f2f]" />
          </div>
        </div>

        {/* Ürün Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((product) => (
            <div key={product.id} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition duration-300">
              <div className="relative group">
                <div className="h-64 bg-[#fefae0] flex items-center justify-center">
                  <span className="text-[#2f2f2f]">Ürün Görseli</span>
                </div>
                <div className="absolute top-3 right-3 flex flex-col space-y-2 opacity-0 group-hover:opacity-100 transition">
                  <button className="bg-white p-2 rounded-full shadow-md hover:bg-[#2f2f2f] hover:text-white transition">
                    <FiHeart />
                  </button>
                  <button className="bg-white p-2 rounded-full shadow-md hover:bg-[#2f2f2f] hover:text-white transition">
                    <FiShoppingCart />
                  </button>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-[#2f2f2f] bg-opacity-70 text-[#fefae0] py-1 px-3 text-sm">
                  {product.category}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-lg font-medium text-[#2f2f2f] mb-1">{product.name}</h3>
                <div className="flex justify-between items-center">
                  <span className="text-[#2f2f2f] font-bold">₺{product.price}</span>
                  <button className="bg-[#2f2f2f] hover:bg-[#1a1a1a] text-[#fefae0] px-4 py-1 rounded-full text-sm transition">
                    Sepete Ekle
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Sayfalama */}
        <div className="flex justify-center mt-12">
          <div className="flex space-x-2">
            <button className="px-4 py-2 bg-[#2f2f2f] text-[#fefae0] rounded-full">1</button>
            <button className="px-4 py-2 bg-white text-[#2f2f2f] hover:bg-[#2f2f2f] hover:text-[#fefae0] rounded-full transition">2</button>
            <button className="px-4 py-2 bg-white text-[#2f2f2f] hover:bg-[#2f2f2f] hover:text-[#fefae0] rounded-full transition">3</button>
            <button className="px-4 py-2 bg-white text-[#2f2f2f] hover:bg-[#2f2f2f] hover:text-[#fefae0] rounded-full transition">İleri</button>
          </div>
        </div>
      </div>

      {/* Footer (Ana sayfayla aynı) */}
     
    </div>
  );
}